import { Empty, Tree } from "antd";
import React, { useState, useEffect } from "react";
import { transformData } from "../../utils/treeFolder";

const { DirectoryTree } = Tree;

const FolderTreeComponent = ({
  data = [],
  onSelect = () => {},
  onExpand = () => {},
  draggable = false,
  currentKey,
  listSelects = [],
  listExpands = [],
  setListSelects = () =>{},
  setListExpands = ()=>{},
  ...others
}) => {
  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    setTreeData(data);
  }, [data]);
  const hadnleExpands = (keys) => {
    onExpand(keys);
    setListExpands(keys)
  };

  const handleSelect = (keys, info) => {
    onSelect(keys,info)
    setListSelects(keys);
  };

  return (
    <div className="folderTreeEquipmentContainer equipment-tree-detail">
      {treeData.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <DirectoryTree
          expandedKeys={listExpands}
          selectedKeys={listSelects}
          key={currentKey || 0}
          treeData={treeData}
          onSelect={handleSelect}
          onExpand={hadnleExpands}
          draggable={draggable}
          {...others}
        />
      )}
    </div>
  );
};

export default FolderTreeComponent;
